import React from 'react';
import { motion } from 'framer-motion';

const AnimatedBackground = ({ variant = 'default' }) => {
    const variants = {
        default: ['#667eea', '#764ba2', '#f093fb'],
        blue: ['#4facfe', '#00f2fe', '#43e97b'],
        purple: ['#fa709a', '#fee140', '#30cfd0'],
        dark: ['#0f2027', '#203a43', '#2c5364'],
    };

    const colors = variants[variant] || variants.default;

    return (
        <div className="fixed inset-0 pointer-events-none overflow-hidden -z-10">
            {/* Animated mesh gradient orbs */}
            <motion.div
                className="absolute w-[800px] h-[800px] rounded-full blur-3xl opacity-20"
                style={{
                    background: `radial-gradient(circle, ${colors[0]} 0%, transparent 70%)`,
                    top: '-20%',
                    left: '-10%',
                }}
                animate={{
                    x: [0, 100, 0],
                    y: [0, 50, 0],
                    scale: [1, 1.2, 1],
                }}
                transition={{
                    duration: 20,
                    repeat: Infinity,
                    ease: 'easeInOut',
                }}
            />

            <motion.div
                className="absolute w-[600px] h-[600px] rounded-full blur-3xl opacity-20"
                style={{
                    background: `radial-gradient(circle, ${colors[1]} 0%, transparent 70%)`,
                    top: '30%',
                    right: '-5%',
                }}
                animate={{
                    x: [0, -80, 0],
                    y: [0, 100, 0],
                    scale: [1, 1.1, 1],
                }}
                transition={{
                    duration: 25,
                    repeat: Infinity,
                    ease: 'easeInOut',
                }}
            />

            <motion.div
                className="absolute w-[700px] h-[700px] rounded-full blur-3xl opacity-15"
                style={{
                    background: `radial-gradient(circle, ${colors[2]} 0%, transparent 70%)`,
                    bottom: '-10%',
                    left: '30%',
                }}
                animate={{
                    x: [0, 50, 0],
                    y: [0, -50, 0],
                    scale: [1, 1.15, 1],
                }}
                transition={{
                    duration: 30,
                    repeat: Infinity,
                    ease: 'easeInOut',
                }}
            />

            {/* Noise texture overlay */}
            <div
                className="absolute inset-0 opacity-[0.015]"
                style={{
                    backgroundImage: `url("data:image/svg+xml,%3Csvg viewBox='0 0 400 400' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noiseFilter'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='4' numOctaves='3' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23noiseFilter)'/%3E%3C/svg%3E")`,
                }}
            />
        </div>
    );
};

export default AnimatedBackground;
